import { ContentExplorer } from '../containers/content'

const ContentPage = () => {
  return (
    <div className='pb-8'>
      <ContentExplorer />
    </div>
  )
}

export default ContentPage
